import * as React from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  const redondearDosDecimales = (valor) => {
    if (valor) return Math.round((valor + Number.EPSILON) * 100) / 100;
    else return "0.00";
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#484d50",
      color: "#fffcfc",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 12,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <StyledTableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </StyledTableCell>
        <StyledTableCell component="th" scope="row">
          {row.Fecha}
        </StyledTableCell>
        <StyledTableCell align="right">{row.Toneladas}</StyledTableCell>
        <StyledTableCell align="right">{row.AuEq_Gr_t}</StyledTableCell>
        <StyledTableCell align="right">{row.Au_Gr_t}</StyledTableCell>
        <StyledTableCell align="right">{row.Ag_gr_t}</StyledTableCell>

        <StyledTableCell align="right">{row.Cu_pct}</StyledTableCell>
        <StyledTableCell align="right">{row.Fe_pct}</StyledTableCell>
        <StyledTableCell align="right">{row.S_pct}</StyledTableCell>
        <StyledTableCell align="right">{row.As_pct}</StyledTableCell>
        <StyledTableCell align="right">{row.Bi_ppm}</StyledTableCell>
        <StyledTableCell align="right">{row.Cd_ppm}</StyledTableCell>
        <StyledTableCell align="right">{row.Zn_pct}</StyledTableCell>
        <StyledTableCell align="right">{row.AuEq_Oz}</StyledTableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={15}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }} className="max-h-[150px] overflow-y-auto">
              <Table size="small">
                <TableBody>
                  {row.dataAgrupada.map((subItem, index) => (
                    <StyledTableRow key={subItem[8]}>
                      {/* Clave */}
                      <StyledTableCell component="th" scope="row">
                        {subItem[8]}
                      </StyledTableCell>

                      {/* Toneladas */}
                      <StyledTableCell component="th" scope="row">
                        {redondearDosDecimales(subItem[15])}
                      </StyledTableCell>

                      {/*   AuEq Gr/t   */}
                      <StyledTableCell align="left">
                        {redondearDosDecimales(subItem[17])}
                      </StyledTableCell>

                      {/*    Au Gr/t    */}
                      <StyledTableCell align="right">
                        {redondearDosDecimales(subItem[18])}
                      </StyledTableCell>

                      {/*    Ag gr/t    */}
                      <StyledTableCell align="right">
                        {redondearDosDecimales(subItem[20])}
                      </StyledTableCell>

                      {/*     Cu%     */}
                      <StyledTableCell align="right">
                        {redondearDosDecimales(subItem[21])}
                      </StyledTableCell>

                      {/*      Fe %      */}
                      <StyledTableCell align="right">
                        {redondearDosDecimales(subItem[22])}
                      </StyledTableCell>

                      {/*       S %       */}
                      <StyledTableCell align="right">
                        {redondearDosDecimales(subItem[27])}
                      </StyledTableCell>

                      {/*        As %        */}
                      <StyledTableCell align="right">
                        {redondearDosDecimales(subItem[23])}
                      </StyledTableCell>

                      {/*        Bi_ppm         */}
                      <StyledTableCell align="right">
                        {redondearDosDecimales(subItem[24])}
                      </StyledTableCell>

                      {/*         Cd_ppm          */}
                      <StyledTableCell align="right">
                        {redondearDosDecimales(subItem[25])}
                      </StyledTableCell>

                      {/*          Zn %           */}
                      <StyledTableCell align="right">
                        {redondearDosDecimales(subItem[26])}
                      </StyledTableCell>

                      {/*          AuEq Oz   ??       */}
                      <StyledTableCell align="right">
                        {subItem[50]}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function FirstCollapsibleTable({ rows, resumenPonderados }) {
  
  // Estilo para el footer sticky:
  const StickyFooterCell = styled(TableCell)({
    position: 'sticky',
    bottom: 0,
    zIndex: 2,
    background: '#fff', // Asegura contraste con el contenido
  });

  return (
    <TableContainer component={Paper} sx={{ maxHeight: "60vh", width: "100%" }}>
      <Table aria-label="collapsible table" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Etiquetas de fila
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Toneladas
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              AuEq Gr/t
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Au Gr/t
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Ag gr/t
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Cu%
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Fe %
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              S %
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              As %
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Bi_ppm
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Cd_ppm
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              Zn %
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600, color: "#2e3a3f" }}>
              AuEq Oz
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <Row key={row.name} row={row} />
          ))}
        </TableBody>
        
        <TableFooter>
          <TableRow>
            <StickyFooterCell  sx={{background: "#f5f5f5"}}/>
            <StickyFooterCell  sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              Total General
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>  
              {resumenPonderados.Toneladas}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f",  background: "#f5f5f5" }}>
              {resumenPonderados.AuEq_Gr_t}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.Au_Gr_t}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.Ag_gr_t}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.Cu_pct}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.Fe_pct}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.S_pct}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.As_pct}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.Bi_ppm}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.Cd_ppm}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.Zn_pct}
            </StickyFooterCell >
            <StickyFooterCell  align="right" sx={{ fontWeight: 600, color: "#2e3a3f", background: "#f5f5f5" }}>
              {resumenPonderados.AuEq_Oz}
            </StickyFooterCell >
          </TableRow>
        </TableFooter>

      </Table>
    </TableContainer>
  );
}